(function ($, window, undefined) {

    $('form#formTrabalheConosco fieldset .form-row:last-child *, .codigo-colaborador *').on('keydown', function (e) {

        if (e.keyCode == 9) e.preventDefault()

    });


    $('.carousel-controls .carousel-btn.next').on('click', function () {
        var move = ($(this).closest('.carousel-controls').siblings('ul'));

        if (!$(move).find('li.active').is(':last-child')) {
            $(move).animate({
                top: '-=' + $(move).find('li').css('height')
            }, 500, function () {
                $(move).find('li.active').removeClass('active').next().addClass('active');
            });

        }
    });


    $('.carousel-controls .carousel-btn.prev').on('click', function () {
        var move = ($(this).closest('.carousel-controls').siblings('.carousel-wrapper').find('ul'));

        if (!$(move).find('li.active').is(':first-child')) {
            $(move).animate({
                top: '+=' + $(move).find('li').css('height')
            }, 500, function () {
                $(move).find('li.active').removeClass('active').prev().addClass('active');
            });
        }




    });

    /*
	 * Formulário de Atualizar Cadastro - Validação
	 */
    (function () {
        'use strict';

        if ($.fn.validate) {

            $('.form-atualizar').validate({
                events: 'change keyup',
                eachInvalid: function () {
                    if (!$(this).hasClass('invalid')) {
                        var inputName = $(this).parents('label').find('.texto-label').text();
                        $(this).addClass('invalid');
                        $(this).parents('label').append('<span class="erro msg-validacao">' + inputName + ' é obrigatório</span>');
                    }
                },
                eachValid: function () {
                    $(this).removeClass('invalid');
                    $(this).parents('label').find('.erro').remove();
                }
            });

        }
    }());

    /*
	 * Formulário de Atualizar Cadastro - Envio
	 */
    (function () {
        'use strict';

        $('#popupAtualizar').on('show.bs.modal', function () {
            setTimeout(function () {
                $('.form-atualizar').find('input')[0].focus();
            }, 1000);
        });

        $('.form-atualizar').on('submit', function (event) {
            var $form = $(this);
            
            
            if (event) {
                event.preventDefault();
            }

            if ($form.validate('isvalid')) {
                $.ajax({
                    url: $form.attr('action'),
                    type: $form.attr('method'),
                    dataType: 'json',
                    data: $form.serialize(),
                    beforeSend: function () {
                        $form.find('.botao').addClass('loading');
                    },
                    success: function (response) {
                        $form.find('.botao').removeClass('loading');

                        var $popup = $('#popupAtualizar');
                        //var $popupBody = $popup.find('.modal-body');
                        var $popupFooter = $popup.find('.modal-footer');

                        // Se o resultado for true, monta o modal com sucesso.
                        if (response.status === true) {

                            $popupFooter.empty();

                            $('<p/>', {
                                'class': 'success',
                                'html': '<i class="icone-sucesso-small"></i> Enviamos um e-mail com instruções para atualizar o seu cadastro.'
                            }).appendTo($popupFooter).slideDown(300);

                            setTimeout(function () {
                                $popup.modal('hide');
                                $popupFooter.empty();
                                $form[0].reset();
                            }, 3000);

                        } else {

                            // Se for false, monta o modal com erro.
                            $popupFooter.empty();

                            $('<p/>', {
                                'class': 'error',
                                'html': '<i class="icone-erro-small"></i> Não foi possível enviar as instruções para atualizar o cadastro.'
                            }).appendTo($popupFooter).slideDown(300);

                        }
                    }
                });
            }
        });
    }());

    /*
	 * Formulário de Pré-Cadastro - Validação
	 */
    (function () {
        'use strict';

        if ($.fn.validate) {

            $('.form-cadastro').validate({
                events: 'change keyup',
                conditional: {
                    cpf: function validaCPF(cpf) {
                        cpf = cpf.replace(/[^0-9]/gi, '');
                        var numeros, digitos, soma, i, resultado, digitos_iguais;
                        digitos_iguais = 1;
                        if (cpf.length < 11)
                            return false;
                        for (i = 0; i < cpf.length - 1; i++)
                            if (cpf.charAt(i) != cpf.charAt(i + 1)) {
                                digitos_iguais = 0;
                                break;
                            }
                        if (!digitos_iguais) {
                            numeros = cpf.substring(0, 9);
                            digitos = cpf.substring(9);
                            soma = 0;
                            for (i = 10; i > 1; i--)
                                soma += numeros.charAt(10 - i) * i;
                            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                            if (resultado != digitos.charAt(0))
                                return false;
                            numeros = cpf.substring(0, 10);
                            soma = 0;
                            for (i = 11; i > 1; i--)
                                soma += numeros.charAt(11 - i) * i;
                            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                            if (resultado != digitos.charAt(1))
                                return false;
                            return true;
                        }
                        else
                            return false;
                    }
                },
                eachInvalid: function () {
                    if (!$(this).hasClass('invalid')) {
                        var inputName = $(this).parents('label').find('.texto-label').text();
                        $(this).addClass('invalid');
                        $(this).parents('label').append('<span class="erro msg-validacao">' + inputName + ' é obrigatório</span>');
                    }
                },
                eachValid: function () {
                    $(this).removeClass('invalid');
                    $(this).parents('label').find('.erro').remove();
                }
            });

        }
    }());

    /*
	 * Formulário de Pré-Cadastro - Envio
	 */
    (function () {
        'use strict';

        $('.form-cadastro').on('submit', function (event) {
            var $form = $(this);

            if (event) {
                event.preventDefault();
            }

            if ($form.validate('isvalid')) {

                $.ajax({
                    url: $form.attr('action'),
                    type: $form.attr('method'),
                    dataType: 'json',
                    data: $form.serialize(),
                    beforeSend: function () {
                        $form.find('.botao').addClass('loading');
                    },
                    success: function (response) {
                        $form.find('.botao').removeClass('loading');

                        var $popup = $('#popupCadastro');
                        var $popupBody = $popup.find('.modal-body');
                        var $popupFooter = $popup.find('.modal-footer');

                        // Se o resultado for true, monta o modal com sucesso.
                        if (response.status === true) {

                            $popupBody.empty();
                            $popupFooter.empty();

                            $('<div/>', {
                                'class': 'icone-sucesso modal-icon'
                            }).appendTo($popupBody);

                            $('<p/>', {
                                'class': 'modal-title',
                                'text': 'Cadastro realizado.'
                            }).appendTo($popupBody);

                            $('<p/>', {
                                'text': 'Enviamos ao seu email um link de confirmação.'
                            }).appendTo($popupBody);

                            $('<p/>', {
                                'html': 'Caso não tenha recebido <a href="javascript:">clique aqui</a> para reenviar.'
                            }).appendTo($popupFooter);

                            $popup.modal('show');

                            setTimeout(function () {
                                $popup.modal('hide');
                                $form[0].reset();
                            }, 5000);

                        } else {
                            // Se for false, monta o modal com erro.
                            $popupBody.empty();
                            $popupFooter.empty();

                            $('<div/>', {
                                'class': 'icone-erro modal-icon'
                            }).appendTo($popupBody);

                            $('<p/>', {
                                'class': 'modal-title',
                                'text': response.mensagem
                            }).appendTo($popupBody);

                            $('<p/>', {
                                'text': 'Utilize outro endereço de e-mail.'
                            }).appendTo($popupBody);

                            $('<p/>', {
                                'text': 'Para dúvidas entre em contato com suporte@advisebrasil.com.br.'
                            }).appendTo($popupFooter);

                            $popup.modal('show');
                        }
                    }
                });
            }
        });
    }());

    /*
	 * Carrossel de Depoimentos
	 */
    (function () {
        'use strict';

        if ($('#depoimentos').length > 0) {
            $('#depoimentos').owlCarousel({
                stopOnHover: true,
                items: 1,
                nav: true,
                singleItem: true,
                autoHeight: true
            });
        }
    }());

    /*
	 * Efeito scroll no botão "Ver vagas"
	 */
    (function () {
        'use strict';

        $('.btn-ver-vagas').on('click', function (event) {
            event.preventDefault();
            var $anchor = $(this);
            $('html, body').stop().animate({
                scrollTop: $($anchor.attr('href')).offset().top - 65
            }, 1500, 'easeInOutExpo');
        });
    }());

    /*
	 * Máscaras de validação
	 */
    (function () {
        'use strict';

        $('.input-cpf').mask('000.000.000-00', {
            reverse: true
        });

        var formatarTelefone = function (val) {
            return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
        },
		telefoneOptions = {
		    onKeyPress: function (val, e, field, options) {
		        field.mask(formatarTelefone.apply({}, arguments), options);
		    }
		};

        $('.input-telefone').mask(formatarTelefone, telefoneOptions);
    }());

    /*
	 * Função que preenche no input o upload de arquivos
	 */
    (function () {
        'use strict';

        $('.file input').on('change', function () {
            var path = $(this).val();
            path = path.substr(path.lastIndexOf('\\') + 1);
            $('.file-custom').text(path);
            $('.file-custom').addClass('filled');
        });
    }());

    /*
	 * Compartilhamento de vagas via Twitter
	 */
    App.shareTwitter = function (vaga) {
        var myWindow, width = 650, height = 250;

        var text = encodeURIComponent('A Advise Brasil está com vaga aberta para ' + vaga + '. Mais detalhes em');
        var link = encodeURIComponent(document.URL);
        var url = 'https://twitter.com/intent/tweet?text=' + text + '&url=' + link;

        var centerLeft = (screen.width / 2) - (width / 2);
        var centerTop = (screen.height / 2) - (height / 2);

        myWindow = window.open(url, 'Twitter', 'scrollbars=1, width=' + width + ', height=' + height + ', left=' + centerLeft + ', top=' + centerTop);
        myWindow.focus();
    };

    /*
	 * Compartilhar vaga via LinkedIn
	 */
    App.shareLinkedin = function (vaga) {
        var myWindow, width = 650, height = 500;

        var title = encodeURIComponent('A Advise Brasil está com vaga aberta para ' + vaga + '. Acesse o site para ver mais detalhes.');
        var text = encodeURIComponent('A Advise Brasil está com vaga aberta para ' + vaga + '. Acesse o site para ver mais detalhes.');
        var link = encodeURIComponent(document.URL);
        var url = 'https://www.linkedin.com/shareArticle?mini=true&url=' + link + '&title=' + title + '&summary=' + text;

        var centerLeft = (screen.width / 2) - (width / 2);
        var centerTop = (screen.height / 2) - (height / 2);

        myWindow = window.open(url, 'LinkedIn', 'scrollbars=1, width=' + width + ', height=' + height + ', left=' + centerLeft + ', top=' + centerTop);
        myWindow.focus();
    };

    /*
	 * Compartilhar vaga via Facebook
	 */
    App.shareFacebook = function (vaga) {
        var myWindow, width = 650, height = 250;

        var link = encodeURIComponent(document.URL);
        var url = 'https://www.facebook.com/sharer/sharer.php?u=' + link + '&description=' + 'A Advise Brasil está com vaga aberta para ' + vaga + '. Acesse o site para ver mais detalhes.';

        var centerLeft = (screen.width / 2) - (width / 2);
        var centerTop = (screen.height / 2) - (height / 2);

        myWindow = window.open(url, 'Facebook', 'scrollbars=1, width=' + width + ', height=' + height + ', left=' + centerLeft + ', top=' + centerTop);
        myWindow.focus();
    };

    /*
	 * Botão compartilhar das redes sociais
	 */
    (function () {
        'use strict';

        $('.icone-share-facebook').on('click', function (event) {
            event.preventDefault();
            var cargo = $(this).data('vaga');
            App.shareFacebook(cargo);
        });

        $('.icone-share-twitter').on('click', function (event) {
            event.preventDefault();
            var cargo = $(this).data('vaga');
            App.shareTwitter(cargo);
        });

        $('.icone-share-linkedin').on('click', function (event) {
            event.preventDefault();
            var cargo = $(this).data('vaga');
            App.shareLinkedin(cargo);
        });

    }());

    /*
	 * Botão Candidatar-se a vaga
	 */
    (function () {
        'use strict';

        $(document).on('click', '.btn-candidatar', function (event) {
            event.preventDefault();

            $('html, body').stop().animate({
                scrollTop: $('.trabalhe-conosco').offset().top - 75
            }, 1500, 'easeInOutExpo', function () {
                $('.form-cadastro').find('input')[0].focus();
            });

            $('#tipoCadastro').val(1);
        });

    }());

}(jQuery, window));